<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain rodape>
      <Compras />
    </InternaMain>
    <Rodape />
  </Wrapper>
</template>

<script>

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import Rodape from '@/components/Rodape.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import Compras from '@/components/Compras/Abas.vue';
import api from '@/api';

export default {
  name: 'MinhasCompras',

  components: {
    Wrapper,
    Topo,
    Rodape,
    MenuLateral,
    InternaMain,
    Compras,
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === 'login') {
      next((vm) => {
        vm.scoreConsumidor();
      });
    }

    next();
  },

  methods: {
    async scoreConsumidor() {
      await api.post('/consumer_score', {
        action: 'login',
      });
    },
  },
};
</script>
